"use strict";
function eventFinanceSummary(booking={}) {
 if(booking.sessionProgramId){
  // Cancelling a visit does not cancel the package contract or erase its receivable.
  const money=value=>Math.max(0,Math.round((Number(value)||0)*100)/100);
  const expected=money(booking.totalPrice);
  const net=money(booking.paidAmount??booking.amountCharged??booking.payment?.paidAmount);
  const refunded=money(booking.refundedAmount??booking.payment?.refundedAmount);
  return {net,refunded,closed:false,hasActivity:expected>0||net>0||refunded>0,amount:expected,pending:money(expected-net)};
 }
 if(booking.eventBookingFlowVersion!=='event_booking_approval_first_v1')return null;
 const amount=value=>Math.max(0,Math.round((Number(value)||0)*100)/100);
 const net=amount(booking.serviceCollectedAmount??booking.paidAmount);
 const refunded=amount(booking.refundedAmount??booking.payment?.refundedAmount);
 const closed=['cancelled','canceled','rejected','payment_expired','deleted'].includes(String(booking.status||booking.confirmationStatus).toLowerCase());
 const expected=amount(booking.totalPrice);
 return {net,refunded,closed,hasActivity:net>0||refunded>0,
  amount:closed?amount(net+refunded):expected,
  pending:closed?0:amount(expected-net),
 };
}
// Closed events must not turn contractual commission estimates into a payable.
// Preserve only an explicit amount already marked paid; never derive it from revenue.
function closedEventWorkerPayout(booking={}) {
 const cancelledSession=booking.sessionProgramId && ['cancelled','canceled','rejected','no_show','no-show','deleted'].includes(String(booking.status||'').toLowerCase());
 if(!cancelledSession && !eventFinanceSummary(booking)?.closed)return null;
 const paid=String(booking.workerPayoutStatus??booking.payment?.workerPayoutStatus??'').trim().toLowerCase()==='paid';
 if(!paid)return 0;
 const value=Number(booking.totalWorkerPayoutAmount??booking.workerPayoutAmount??booking.workerPayout??booking.payment?.totalWorkerPayoutAmount??booking.payment?.workerPayoutAmount??0);
 return Number.isFinite(value)?Math.max(0,Math.round(value*100)/100):0;
}
module.exports={eventFinanceSummary,closedEventWorkerPayout};
